import account from "./account.json";
import accountLinks from "./accountLinks.json";
import extraLinks from "./extraLinks.json";
import pages from "./pages.json";
import help from "./help.json";
import policies from "./policies.json";
import aboutUs from "./aboutUs.json";

export default {
  account,
  accountLinks,
  extraLinks,
  pages,
  help,
  policies,
  aboutUs,
};
